import React from "react";
import ExportButton from "../export/ExportButton";

/**
 * R6 A12 — Sticky bulk actions bar at bottom of viewport.
 */
export default function BulkActionsBar({
  selectedCount,
  selectionMode,
  canManage,
  onAssign,
  onStatus,
  onLogActivity,
  onAddNextContact,
  onExport,
  onDeselect,
  onBulkCompleteOverdue,
  onBulkSuspendOverdue,
}) {
  if (!selectionMode) return null;
  return (
    <div className="r6-bulk-actions-bar">
      <span className="r6-bulk-count">{selectedCount} selected</span>
      {canManage && (
        <button
          className="btn btn-secondary btn-sm"
          onClick={onAssign}
          disabled={!selectedCount}
        >
          <i className="fas fa-user-tag" /> Assign to rep
        </button>
      )}
      <button
        className="btn btn-secondary btn-sm"
        onClick={onStatus}
        disabled={!selectedCount}
      >
        <i className="fas fa-exchange-alt" /> Mark status
      </button>
      {/*Temporarily hiding will remove after confirmation*/}
      {/*<button
        className="btn btn-secondary btn-sm"
        onClick={onBulkCompleteOverdue}
        disabled={!selectedCount}
      >
        <i className="fas fa-check" /> Mark Overdue Complete
      </button>

      <button
        className="btn btn-secondary btn-sm"
        onClick={onBulkSuspendOverdue}
        disabled={!selectedCount}
      >
        <i className="fas fa-pause" /> Suspend Overdue
      </button>*/}
      {/*<button className="btn btn-secondary btn-sm" onClick={onLogActivity} disabled={!selectedCount}>
        <i className="fas fa-plus-circle" /> Log activity
      </button>
      <button className="btn btn-secondary btn-sm" onClick={onAddNextContact} disabled={!selectedCount}>
        <i className="fas fa-calendar-plus" /> Add Next Contact
      </button>
      */}
      <ExportButton
        getExportData={onExport}
        label="Export selected"
        disabled={!selectedCount}
        dropUp
      />

      <button className="btn btn-ghost btn-sm" onClick={onDeselect}>
        Deselect all
      </button>
    </div>
  );
}
